var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QRcode',{ref:"QRcodeRef",attrs:{"onError":_vm.onError,"onSuccess":_vm.onSuccess,"onClose":_vm.onClose,"workerPath":"/js/qrWork.js","config":{tipText:_vm.tipText, backButtonText:_vm.back}}})}
var staticRenderFns = []

export { render, staticRenderFns }